/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:03:45
 * @Description: file content
 */ 
/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import OriginRadio from 'bee-radio';
import { getSysFieldid } from '@platform/api';

require('bee-radio/build/Radio.css');
require('./index.less');

const { RadioGroup: OriginRadioGroup, RadioButton: OriginRadioButton } = OriginRadio;

class RadioGroup extends Component {
	render() {
		return <div
			className={`radio-group-hotkey-wrapper`}
			onKeyDown={(e) => {
				if ([e.keyCode, e.which, e.charCode].find((e) => e === 13) || e.key === "Enter") {
					this.props.onEnter && this.props.onEnter({ e: e });
				}
			}}
		>
			<OriginRadioGroup {...this.props}>{this.props.children}</OriginRadioGroup>
		</div>;
	}
}
class RadioButton extends Component {
	render() {
		// 居然不支持 className
		return <OriginRadioButton {...this.props} className={`${this.props.className} nc-radio`}>{this.props.children}</OriginRadioButton>;
	}
}

class Radio extends Component {
	render() {
		let {
			fieldid,
			...others
		} = this.props;


		if (!fieldid) {
			fieldid = null;
			if (this.props.children) {
				if (typeof this.props.children === "string") {
					fieldid = this.props.children;
				} else if (this.props.children instanceof Array) {
					fieldid = this.props.children[0];
				}
			}
		}

		fieldid = getSysFieldid(fieldid);

		return <OriginRadio
			{...others}
			fieldid={fieldid ? `${fieldid}_radio` : null}
		>
			{this.props.children}
		</OriginRadio>;
	}
}
export default Radio;

Radio.RadioGroup = RadioGroup;
Radio.RadioButton = RadioButton;
